import { clsx } from "clsx";
import { IconResolver } from "@/components/ui/IconResolver";
import classes from "./Footer.module.scss";
import type { FooterLinkProps } from "./FooterProps";

export function FooterLink(props: FooterLinkProps) {
  const { url, text, icon, className } = props;

  const isExternal = url.startsWith("http");

  return (
    <a
      href={url}
      className={clsx(classes.link, className)}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
    >
      <IconResolver name={icon} size={24} />
      {text}
    </a>
  );
}
